"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeCookbookPrivacyMutationOptions = exports.changeCookbookPrivacyMutation = void 0;
const client_1 = require("@apollo/client");
exports.changeCookbookPrivacyMutation = client_1.gql `
  mutation ChangeCookbookPrivacy(
    $id: String!
    $input: ChangeCookbookPrivacyInput!
  ) {
    changeCookbookPrivacy(id: $id, input: $input) {
      __typename
      cookbook {
        __typename
        id
        privacy
        shareId
      }
    }
  }
`;
exports.changeCookbookPrivacyMutationOptions = (variables) => ({
    variables,
});
//# sourceMappingURL=ChangeCookbookPrivacy.js.map